module.exports = __webpack_public_path__ + "img/collection-engagementRings025Carat@2x.0d45a9f.jpg";